(function() {
  var ScrollHelper,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  ScrollHelper = App.load("core::ScrollHelper");

  exports.Contacts_Handler = (function(superClass) {
    extend(Contacts_Handler, superClass);

    function Contacts_Handler(name, data) {
      if (data == null) {
        data = {};
      }
      Contacts_Handler.__super__.constructor.call(this, name, data);
      this.subHandlers = {
        "Invite": {
          "class": "grower::handlers/contacts/tabs/Invite_Tab_Handler"
        },
        "Confirm": {
          "class": "grower::handlers/contacts/tabs/Confirm_Tab_Handler"
        },
        "Contacts": {
          "class": "grower::handlers/contacts/tabs/Contacts_Tab_Handler"
        },
        "Add_Permission_Dialog": {
          "class": "grower::handlers/contacts/Add_Permission_Dialog"
        },
        "Edit_Permission_Dialog": {
          "class": "grower::handlers/contacts/Edit_Permission_Dialog"
        },
        "Remove_Permission_Dialog": {
          "class": "grower::handlers/contacts/Remove_Permission_Dialog"
        },
        "View_User_Dialog": {
          "class": "grower::handlers/contacts/View_User_Dialog"
        }
      };
    }

    Contacts_Handler.prototype.init = function() {
      this.layoutSelector = App.sidebar.contentDiv();
      this.layoutUrl = "backend/grower/contacts/load-layout";
      this.defaultSub = "Contacts";
      return this.loadLayout();
    };

    Contacts_Handler.prototype.afterLoadLayout = function(selector, data) {
      var sub;
      sub = this.createSubHandler(this.defaultSub);
      if (sub) {
        return sub.init();
      }
    };

    Contacts_Handler.prototype.viewUser = function(e, obj, selector) {
      var ths;
      ths = this;
      ths.destroySubHandler('view_user', true);
      return ths.viewUserReg(e, $(obj), selector);
    };

    Contacts_Handler.prototype.viewUserReg = function(e, obj, selector) {
      var ths, users_id, viewR;
      ths = this;
      e.preventDefault();
      obj.parents('tr').addClass('darken');
      users_id = obj.parents('tr').data('users_id');
      viewR = this.createSubHandler('View_User_Dialog', 'view_user');
      if (viewR) {
        viewR.amountOfInfo = 'big';
        viewR.loadLayoutPostOptions = {
          user_id: users_id
        };
        viewR.afterHidden = function() {
          return $(".list-table").find('tr[data-users_id="' + users_id + '"]').removeClass('darken');
        };
        viewR.init();
        return $('#' + viewR.id).addClass('veiwR_dialog');
      }
    };

    Contacts_Handler.prototype.viewUserS = function(e, obj, selector) {
      var ths;
      ths = this;
      ths.destroySubHandler('view_user', true);
      return ths.viewUserSmall(e, $(obj), selector);
    };

    Contacts_Handler.prototype.viewUserSmall = function(e, obj, selector) {
      var ths, users_id, viewS;
      ths = this;
      e.preventDefault();
      obj.parents('tr').addClass('darken');
      users_id = obj.parents('tr').data('users_id');
      viewS = this.createSubHandler('View_User_Dialog', 'view_user');
      if (viewS) {
        viewS.amountOfInfo = 'small';
        viewS.loadLayoutPostOptions = {
          user_id: users_id
        };
        viewS.afterHidden = function() {
          return obj.parents('tr').removeClass('darken');
        };
        return viewS.init();
      }
    };

    Contacts_Handler.prototype.tabLoadLayoutCallback = function(selector, data) {
      var ls, msgwriter, table, ths;
      ths = this;
      msgwriter = App.sidebar.messageWriter();
      msgwriter.message_writer('success', 'Loaded!');
      msgwriter.message_writer('hide');
      ths = this;
      $(this.layoutSelector).find('#addpermission, #editpermission, #removepermission').click(function(e) {
        var handler, sub;
        e.preventDefault();
        handler = $(this).data('handler');
        sub = ths.createSubHandler(handler);
        if (sub) {
          return sub.init();
        }
      });
      ls = this.parent.layoutSelector;
      $.post('backend/grower/contacts/confirmtab/get-numconfirmable-ajax', function(json) {
        if (json.data > 0) {
          return $(ls).find('.num-confirmable').empty().append("(" + json.data + ")");
        }
      });
      App.sidebar.contentDiv().find(".tab-content").resizr();
      table = $(selector).find(".list-table");
      $(selector).find(".table-container").resizr();
      ScrollHelper.make(table, {
        height: $(selector).find(".table-container").resizr('size')
      });
      return table.find('tbody tr .row-clickable').bind('click', function(e) {
        table.find('tr').removeClass('darken');
        return ths.viewUser(e, $(this), selector);
      });
    };

    return Contacts_Handler;

  })(Handler);

}).call(this);
